import React, { LabelHTMLAttributes, memo } from "react";
import styled from "styled-components";

/**
|--------------------------------------------------
| 共通部品 - スイッチ
| 
| ★使用例
| const [status, setStatus] = useInitToggle();
| const handleClick = () => {
|     setStatus();
| };
| 
| <PSwitch id="XXX" status={status} handleClick={handleClick} />
|--------------------------------------------------
*/
interface PSwitchProps extends LabelHTMLAttributes<HTMLLabelElement> {
    // ID
    id: string;
    // 状態（ON:true OFF:false）
    status: boolean;
    // クリックイベント
    handleClick: (id: string) => void;
}

const StyledLabel = styled.label`
    display: inline-block;
    position: relative;
    width: 50px;
    height: 25px;
    padding: 5px;
    cursor: pointer;
    background: ${(props) => (props.itemProp === "true" ? "var(--studio-btn-bg)" : "#676767")};
    border-radius: 25px;
    border: 0;

    &::after {
        content: "";
        display: block;
        position: absolute;
        height: 19px;
        width: 19px;
        top: 50%;
        left: ${(props) => (props.itemProp === "true" ? "27px" : "5px")};
        margin-top: -10px;
        background: var(--white);
        border-radius: 50%;
        box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%),
            0px 1px 5px 0px rgb(0 0 0 / 12%);
        box-sizing: border-box;
        transition: left 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    }
`;

function PSwitch({ id, status, handleClick, ...props }: PSwitchProps) {
    return (
        <StyledLabel
            itemProp={String(status)}
            onClick={() => handleClick(id)}
            style={props.style}
        />
    );
}

export default memo(PSwitch);
